import { reducer } from '../reducers/team-member';
import { teamMemberRootSaga } from '../sagas/team-member';
import { saga, store } from '../store';

store.addReducers({ teamMember: reducer });
saga.run(teamMemberRootSaga);
